import $ from 'jquery';
// import mpro from './mpro.init';

// ===================================
// Loading helpers
// ===================================

/**
 * @param {JQuery} $btn
 */
mpro.addButtonLoading = function($btn) {
	$btn.addClass('btn-loading disabled pointer-none').prop('disabled', true)/* .on('click.disableClick', false) */;
};

/**
 * @param {JQuery} $btn
 */
mpro.removeButtonLoading = function($btn) {
	$btn.removeClass('btn-loading disabled pointer-none').prop('disabled', false)/* .off('click.disableClick') */;
};

/**
 * @param {JQuery} $btn
 */
mpro.addButtonDisabled = function($btn) {
	$btn.addClass('disabled').prop('disabled', true);
};

/**
 * @param {JQuery} $btn
 */
mpro.removeButtonDisabled = function($btn) {
	$btn.removeClass('disabled').prop('disabled', false);
};

/**
 * @param {JQuery} $container
 */
mpro.addLoading = function($container) {
	const cData = $container.data();
	if (cData.$loader) {
		cData.$loader.remove();
	}
	const $loader = $('<div class="loader"><div class="loader-wrapper"><div class="loader-animation"></div></div></div>');
	cData.$loader = $loader;
	$container.append($loader);
	// Reflow (don't use external dependency for just the mpro.reflow function)
	void ($loader[0].offsetHeight);
	$loader.addClass('visible').children().addClass('visible');
};

/**
 * @param {JQuery} $container
 */
mpro.removeLoading = function($container) {
	const cData = $container.data();
	const { $loader } = cData;
	if ($loader) {
		cData.$loader = null;
		$loader.removeClass('visible').children().removeClass('visible').end().animate({ fakeProp: 1 }, 300, () => {
			$loader.remove();
		});
	}
};

/**
 * Attach a load animation to a section of the DOM
 *
 * @param {JQuery|HTMLElement} container
 * @param {string|string[]=} modifierClasses
 * @param {{ delay?: number; }=} options
 */
mpro.addContentLoader = (container, modifierClasses, options = {}) => {

	/** @type {JQuery} */
	// @ts-ignore
	const $container = (container instanceof $) ? container : $(container);
	const data = $container.data();
	const modifiers = [modifierClasses || []].flat().map(v => ('loading--' + v));
	const classes = ['loading', ...modifiers].join(' ');
	const delay = ('delay' in options) ? Number(options.delay) : 0 /* 366 */;
	const timer = data._delayedLoadingTimer;

	if (timer) {
		window.clearTimeout(timer);
		data._delayedLoadingTimer = null;
	}

	const exec = () => {
		data._loadingClasses = classes;
		$container.addClass(classes);
		// Reflow (don't use external dependency for just the mpro.reflow function)
		return void ($container[0].offsetHeight);
	};

	// Show later
	if (delay > 0) {
		data._delayedLoadingTimer = window.setTimeout(exec, delay);
	}
	// Show now
	else {
		exec();
	}
};

/**
 * Detach a previously added load animation from a section of the DOM
 *
 * @param {JQuery|HTMLElement} container
 */
mpro.removeContentLoader = (container) => {

	/** @type {JQuery} */
	// @ts-ignore
	const $container = (container instanceof $) ? container : $(container);
	const data = $container.data();
	const classes = data._loadingClasses;
	const timer = data._delayedLoadingTimer;

	if (timer) {
		window.clearTimeout(timer);
		data._delayedLoadingTimer = null;
	}

	classes && $container.removeClass(classes);
	data._loadingClasses = null;
};

/**
 * Return the default loading placeholder text
 */
mpro.getLoadingPlaceholder = () => {
	return '<div class="loading loading--sm" style="min-width: 160px; margin: 0.5rem;"></div>';
};

export default mpro;
